
import { Link } from "react-router-dom"
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  CreditCard,
  DeleteIcon,
  EllipsisVertical,
  File,
  Home,
  LineChart,
  ListFilter,
  MoreVertical,
  Package,
  Package2,
  PanelLeft,
  Search,
  Settings,
  ShoppingCart,
  Truck,
  Users2,
} from "lucide-react"

import { Badge } from "../../component/ui/badge"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb"
import { Button } from "../../component/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Input } from "../../component/ui/input"
import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from "../../component/ui/Pagination"
import { Progress } from "../../component/ui/progress"
import { Separator } from "../../component/ui/separator"
import { Sheet, SheetContent, SheetTrigger } from "../../component/ui/sheet"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table"
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../component/ui/tooltip"
import DataTable2 from "./dataTable2"
import { Switch } from "../ui/switch"
import moment from "moment"
import { useEffect, useState } from "react"
import { getAllInvestorSchemeReport, getAllSchemeReportsAgainstSchemeName, getReportURL } from "../../utils/util"
import { useDispatch, useSelector } from "react-redux"
import { loaderSet } from "../../context/actions/loaderAction"
import { reportOptions } from "../../utils/constant"

export const description =
  "An orders dashboard with a sidebar navigation. The sidebar has icon navigation. The content area has a breadcrumb and search in the header. The main area has a list of recent orders with a filter and export button. The main area also has a detailed view of a single order with order details, shipping information, billing information, customer information, and payment information."

export function DataTable({ selectedFrequency,buttonOptions,isNewReportUpload=false, onRowClick = () => { }, selectedSchemeOptions = [], columns, data, tableFor = "", schemeInfo }) {


  const buttonOptions1 = [
    // {
    //   icon: download,
    //   alt: 'Send Icon',
    //   text: <span className="text-base font-semibold">Download Certificate</span>,
    //   iconHeight: 4,
    //   iconWidth: 18,
    //   iconColor: 'text-[#FFFFFF]',
    //   name: 'Download'
    // },
    {
      icon: DeleteIcon,
      alt: '',
      text: <span className="text-base font-semibold">Delete</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: 'text-[#FFFFFF]',
      name: 'Delete'
    }
  ];

  const [activeTab, setActiveTab] = useState("Weekly");

  useEffect(()=>{
    if(selectedFrequency)
    {

      if(activeTab===selectedFrequency && isNewReportUpload===true)
      {
        handleGetAllSchemeReportData()
      }

      setActiveTab(selectedFrequency)
    }
  },[selectedFrequency,isNewReportUpload])

  const dispatch = useDispatch()
  const [monthlyData, setMonthlyData] = useState([])
  const [quarterlyData, setQuarterlyData] = useState([])
  const [yearlyData, setYearlyData] = useState([])
  const [weeklyData, setWeeklyData] = useState([])
  const [ad_hocData, setAd_hocData] = useState([])

  const getDataForTab = () => {
    if (activeTab === "Monthly") return monthlyData;
    if (activeTab === "Quaterly") return quarterlyData;
    if (activeTab === "Yearly") return yearlyData;
    if (activeTab === "Weekly") return weeklyData;
    if (activeTab === "Ad-hoc") return ad_hocData;

  };
  const [tableData, setTableData] = useState([])
  const [investorSchemeReport, setInvestorSchemeReport] = useState([])

  const investorInfo = useSelector(state => state.investorInfo)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
  }, [activeTab])

  

  const allSchemeDetails = useSelector(state => state.allSchemeDetails)
  const handlePageChange = (page) => {
    const setPageIndex = page - 1
    setCurrentPage(setPageIndex); // Update pageIndex based on selected page
  };

  

  const handleGetAllInvestorSchemeReport = async () => {
    // console.log("allschemdetails",allSchemeDetails)
    const payload = {
      user_id: investorInfo && investorInfo?.user_id,
      scheme_id: allSchemeDetails && allSchemeDetails.length > 0 && allSchemeDetails
        .filter(scheme => {
          if (
            selectedSchemeOptions &&
            selectedSchemeOptions.length > 0
          ) {
            const [name, classType] = selectedSchemeOptions[0]?.split("-");
            return name === scheme?.scheme_name && classType === scheme?.scheme_class;
          }
          return false;
        })
        .map(scheme => scheme.scheme_id),

        report_type: activeTab ? (activeTab==="Quarterly" ? "quaterly" : activeTab.toLowerCase()) : null,
      scheme_name: selectedSchemeOptions && selectedSchemeOptions.length > 0 && selectedSchemeOptions[0]?.split("-")[0],
      scheme_class: selectedSchemeOptions && selectedSchemeOptions.length > 0 && selectedSchemeOptions[0]?.split("-")[1],
      page_no: currentPage,
      per_page: 10
    }
    try {
      const response = await getAllInvestorSchemeReport(payload)
      if (response) {
        setInvestorSchemeReport(response.data)
        setTableData(response.data)
      }
      console.log("handleGetAllInvestorSchemeReport", response)
    } catch (error) {
      console.log("Error in handleGetAllInvestorSchemeReport ", error)
    }
  }

  useEffect(() => {
    if (investorInfo !== null && investorInfo?.user_id !== "" && tableFor !== "SchemeReport") { handleGetAllInvestorSchemeReport() }
  }, [selectedSchemeOptions, investorInfo, activeTab])


  const [schemeReportData, setSchemeReportData] = useState([])


  const handleGetAllSchemeReportData = async () => {
    const payload = {
      user_id: "admin",
      // report_type: activeTab && activeTab.toLowerCase(),
      report_type: activeTab ? (activeTab==="Quarterly" ? "quaterly" : activeTab.toLowerCase()) : null,
      scheme_name: schemeInfo && schemeInfo.scheme_name,
      scheme_class: schemeInfo && schemeInfo.scheme_class,
      scheme_id: schemeInfo && schemeInfo.scheme_id,
      page_no: currentPage,
      per_page: 10
    };
    try {
      const response = await getAllSchemeReportsAgainstSchemeName(payload);
      if (response) {
        await Promise.all([
          new Promise((resolve) => setSchemeReportData(response.data.decryptedReports, resolve)),
          new Promise((resolve) => setTableData(response.data.decryptedReports, resolve)),
          new Promise((resolve) => setTotalPage(response.data.pagination.total_pages, resolve))
        ]);
       
        dispatch(loaderSet(false)); // Loader stops after data is set
      }
      console.log("response for handleGetAllSchemeReportData", response);
    } catch (error) {
      console.log("error in handleGetAllSchemeReportData function", error);
    }
  };

  useEffect(() => {
    if (schemeInfo !== null && schemeInfo?.scheme_name !== "" && tableFor === "SchemeReport") {
      dispatch(loaderSet(true))
      handleGetAllSchemeReportData()
    }

  }, [activeTab, schemeInfo, currentPage])



  const [searchTerm, setSearchTerm] = useState("")
  const searchInputId = `report-search-${tableFor || "default"}`

  const [filteredInvestorReportData, setFilteredInvestorReportData] = useState([])

  useEffect(() => {
    console.log(searchTerm)
    if (searchTerm.length > 0) {
      setFilteredInvestorReportData(tableData.filter((investorReport) => {
        const search = searchTerm.toLowerCase();
        return (
          investorReport.report_type.toLowerCase().includes(search) ||
          investorReport.report_name.toLowerCase().includes(search)

        );
      }))
    }
    else {
      setFilteredInvestorReportData(tableData)
    }

  }, [searchTerm, tableData])


  const handleSchemeReportView = async (report) => {
    try {
      // Check if the report URL is valid before opening
      if (report.report_url) {
        const payload = {
          storedSignedUrl: report?.report_url,
          storedExpirationTime: report?.expired_at,
          fileName: report?.file_name,
          report_id: report?.report_id
        }

        const reportURL = await getReportURL(payload)
        if (reportURL?.code === 200) {

          handleGetAllSchemeReportData()
          console.log("URL", reportURL)
          const url = reportURL?.data.URL
          window.open(url, "_blank");
        }

        // Open the report URL in a new tab
        // window.open(reportUrl, "_blank");
      } else {
        console.log("Invalid report URL");
      }
    } catch (error) {
      console.log("Error in handleSchemeReportView function", error);
    }
  };

  const handleInvestorSchemeReportView = async (report) => {
    try {
      // Check if the report URL is valid before opening
      if (report.report_url) {
        const payload = {
          storedSignedUrl: report?.report_url,
          storedExpirationTime: report?.expired_at,
          fileName: report?.file_name,
          report_id: report?.report_id
        }

        const reportURL = await getReportURL(payload)
        if (reportURL?.code === 200) {

          handleGetAllInvestorSchemeReport()
          console.log("URL", reportURL)
          const url = reportURL?.data.URL
          window.open(url, "_blank");
        }

        // Open the report URL in a new tab
        // window.open(reportUrl, "_blank");
      } else {
        console.log("Invalid report URL");
      }
    } catch (error) {
      console.log("Error in handleSchemeReportView function", error);
    }
  };

  return (
    <div className="flex min-h-screen w-full flex-col pt-0 ">
      <div className="flex flex-col sm:gap-4 sm:py-4 sm:pl-1">

        <main className="grid flex-1 items-start gap-4 p-4 ">
          <div className="grid auto-rows-max items-start gap-4 md:gap-8  lg:col-span-2">

            <Tabs value={activeTab} onValueChange={setActiveTab}  >
              <div className="flex bg-white items-center flex-col ">
                <div className=" flex  w-full flex-col items-start " >
                  <TabsList className="bg-white border-b-2 w-full rounded-none flex justify-start" aria-label="Report frequency filters">
                    {reportOptions.map((tab) => (
                      <TabsTrigger
                        key={tab}
                        value={tab}
                        tabIndex={reportOptions.indexOf(tab) + 1}
                        className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold data-[state=active]:border-b-2 data-[state=active]:border-[#0D215C]"
                        aria-label={`${tab === "Quaterly" ? "Quarterly" : tab} reports`}
                        onClick={() => {
                          setActiveTab(tab)


                        }}
                      >
                        {tab === "Quaterly" ? "Quarterly" : tab}
                      </TabsTrigger>
                    ))}
                  </TabsList>


                </div>
                <div className="w-full flex justify-between items-start p-2">
                  <div className="flex w-full justify-end items-center gap-4">
                    {/* Search Bar */}
                    <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                      <label htmlFor={searchInputId} className="sr-only">Search reports</label>
                      <Search className="h-8 w-6 text-slate-700 pointer-events-none" aria-hidden="true" focusable="false" />
                      <Input
                        id={searchInputId}
                        type="search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        aria-label="Search reports"
                        className="rounded-none border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-lg placeholder:text-slate-600"
                      />
                    </div>

                  
      
                  </div>
                </div>

              </div>
              <TabsContent value={activeTab}>
                <Card x-chunk="dashboard-05-chunk-3">

                  <CardContent>
                    {/* <DataTable2 buttonOptions={buttonOptions} /> */}

                    <Table className="min-w-[720px] table-auto">
                      <TableHeader>
                        <TableRow>
                          {buttonOptions?.length > 0 && (
                            <TableHead scope="col" className="w-[6%] text-left text-[#0D215C] font-semibold">Actions</TableHead>
                          )}
                          <TableHead scope="col" className="text-[#0D215C] font-semibold" >Sr No.</TableHead>
                          {columns?.map((column, index) => (
                            <TableHead key={index} scope="col" className="text-[#0D215C] font-semibold" >{column.header}</TableHead>
                          ))}
                          {
                            tableFor === "SchemeReport" &&
                            (
                              // <TableHead className="" >Status</TableHead>
                              <></>
                            )
                          }
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {
                          filteredInvestorReportData && filteredInvestorReportData?.length > 0 ?
                            filteredInvestorReportData?.map((item, rowIndex) =>
                            (
                              <TableRow className="cursor-default" key={rowIndex}
                              // onClick={() => onRowClick(rowIndex)}
                              >
                                {buttonOptions?.length > 0 && (
                                  <TableCell className="w-[6%] text-left">
                                    <DropdownMenu>
                                      <DropdownMenuTrigger asChild>
                                        <Button
                                          variant="ghost"
                                          className="h-11 w-11 p-0 focus-visible:ring-2 focus-visible:ring-black"
                                          aria-label={`Actions for ${item?.report_name || `report ${rowIndex + 1}`}`}
                                        >
                                          <EllipsisVertical className="h-4 w-4" />
                                        </Button>
                                      </DropdownMenuTrigger>
                                      <DropdownMenuContent align="end">
                                        {buttonOptions.map((option, index) => (
                                          <div key={index}>
                                            <DropdownMenuItem>
                                              <Button
                                                variant="none"
                                                className="flex items-center px-2 gap-4 h-6 text-sm"

                                                onClick={() => {
                                                  if (tableFor === "InvestorSchemeReport") {
                                                    if (option.name === "View") {
                                                      // option.actionHandleInvestorReportView(item.report_url)
                                                      handleInvestorSchemeReportView(item)
                                                    }
                                                    if (option.name === "Download") {
                                                      option.actionHandleInvestorReportView(item.report_url)
                                                    }
                                                  }
                                                  if (tableFor === "SchemeReport") {
                                                    if (option.name === "View") {
                                                      // option.actionHandleSchemeReportView(item)
                                                      handleSchemeReportView(item)

                                                    }
                                                    if (option.name === "Download") {
                                                      option.actionHandleDownloadSchemeReport(item.report_url)
                                                    }
                                                  }
                                                  if (tableFor === "Ticker") {
                                                    if (option.name === "Delete") {

                                                      option.actionHandleDeleteTickerForScheme(item)
                                                      return
                                                    }
                                                    if (option.name === "Edit") {
                                                      return option.actionHandleEditTickerForScheme(item)
                                                    }

                                                  }
                                                  if (tableFor === "Email-Template") {
                                                    if (option.name === "Edit") {
                                                      return option.actionHandleEditEmailTemplate(item)
                                                    }
                                                    if (option.name === "Delete") {
                                                      option.actionHandleDeleteEmailTemplate(item)
                                                      return
                                                    }
                                                  }
                                                }}

                                              >
                                                {option.icon}
                                                <span>{option.text}</span>
                                              </Button>
                                            </DropdownMenuItem>
                                            {index < buttonOptions.length - 1 && (
                                              <DropdownMenuSeparator />
                                            )}
                                          </div>
                                        ))}
                                      </DropdownMenuContent>
                                    </DropdownMenu>
                                  </TableCell>
                                )}
                                <TableCell className="whitespace-nowrap">{rowIndex + 1}</TableCell>
                                {columns?.map((header, colIndex) => (
                                  <TableCell
                                    key={colIndex}
                                    className="whitespace-normal break-words max-w-[320px]"
                                    aria-label={header.id === "report_name" ? `Report name ${item[header.id]} for ${item?.report_type || 'selected period'}` : undefined}
                                    title={header.id === "report_name" ? item[header.id] : undefined}
                                  >
                                    {header.id !== "created_at" ? item[header.id] : moment(item[header.id]).format("DD-MM-YYYY")}
                                  </TableCell>

                                ))}
                                {tableFor === "Ticker" && <TableCell>
                                  <Switch />
                                </TableCell>}
                                {/* Conditionally render the action buttons if buttonOptions exist */}

                              </TableRow>
                            )
                            )
                            :
                            <TableRow>
                              <TableCell colSpan={(columns?.length || 0) + (buttonOptions?.length > 0 ? 2 : 1)} className="h-10 text-center text-slate-600">
                                No reports found.
                              </TableCell>
                            </TableRow>



                        }

                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
                <div className="flex justify-end items-center mt-4">

                  <div>
                    <span className="sr-only" role="status" aria-live="polite">
                      Showing page {currentPage} of {totalPage}
                    </span>
                    <span>
                      Page{" "}
                      <strong>

                        {currentPage}
                        of{" "}
                        {totalPage}
                      </strong>{" "}
                    </span>
                    <label htmlFor={`page-select-${tableFor || 'default'}`} className="sr-only">Select reports page</label>
                    <select
                      id={`page-select-${tableFor || 'default'}`}
                      value={currentPage + 1}
                      onChange={(e) => handlePageChange(Number(e.target.value))}
                      className="p-2 border border-gray-300 rounded ml-2"
                    >
                      {Array.from({ length: totalPage }, (_, index) => index + 1).map((page) => (
                        <option key={page} value={page + 1}>
                          Page {page}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </TabsContent>
            </Tabs>
          </div>
          <div>

          </div>
        </main>
      </div>

    </div>
  )
}
